import type { Template } from "@pdfme/common";
import { generate } from "@pdfme/generator";
import { table, text } from "@pdfme/schemas";
import { merge } from "@pdfme/manipulator";

type pdfInputData = {
  denumire: string;
  cui: string;
  cif: string;
  adresa: string;
  codPostal: string;
  email: string;
  website: string;
  telefon_fix?: string;
  telefon_mobil?: string;
  caen_principal: string;
  caen_secundar?: string;
  salariati_med?: string;
  cifra_afaceri_neta?: string;
  active?: string;
  dimensiune?: string;
  nr_sectoare?: string;
  nr_subsectoare?: string;
  nr_servicii?: string;
  exista_responsabil_legal?: string;
  rl_nume?: string;
  rl_functie?: string;
  rl_telefon?: string;
  rl_email?: string;
  pm_exista?: string;
  pm_mobil?: string;
  pm_fix?: string;
  pm_email?: string;
  intervale_ip?: string;
  furnizare_ue?: string;
  state_membre?: string;
  adrese_ue?: string;
  afara_ue?: string;
  numePersoanaSauFirmaAfaraUe?: string;
  afaraue_email?: string;
  afaraue_domiciliu?: string;
  afaraue_telefon?: string;
  "9a"?: string;
  "9b"?: string;
  "9c"?: string;
  "9d"?: string;
  indentificata_critical?: string;
  avem_doc?: string;
  nr_doc?: string;
  doc_dimensiune?: string;
  art9docs?: string;
  alte_docs?: string;
  evaluare?: string;

  rep_legal_nume?: string;
  rep_legal_functie?: string;
  rep_legal_telefon?: string;
  rep_legal_email?: string;
  pm_nume?: string;

  field38?: string;
  field39?: string;
  field41?: string;
  field42?: string;
  sectoare?: string;
  subsectoare?: string;
  servicii?: string;

  date: string;
  date2: string;
  date3: string;
  date4: string;
};

export async function generatePDFReport(data: {
  template: unknown[];
  inputs: unknown[];
  type: "merge" | undefined;
}) {
  try {
    let pdf;
    if (data.type === "merge" && Array.isArray(data.template)) {
      let pdfs = [];
      for (let i = 0; i < data.template.length; i++) {
        pdfs.push(
          await generate({
            template: data.template[i] as Template,
            inputs: data.inputs[i] as pdfInputData[],
            plugins: { Table: table, Text: text },
          })
        );
      }
      pdf = await merge(pdfs);
    } else {
      pdf = await generate({
        template: (Array.isArray(data.template)
          ? data.template[0]
          : data.template) as Template,
        inputs: data.inputs as pdfInputData[],
        plugins: { Table: table, Text: text },
      });
    }

    // Create a blob from the PDF buffer
    const blob = new Blob([pdf.buffer as unknown as ArrayBuffer], {
      type: "application/pdf",
    });
    const pdfUrl = URL.createObjectURL(blob);

    // Try to open in a new tab
    const newWindow = window.open(pdfUrl, "_blank");

    // If window.open is blocked or returns null (common in production environments)
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      console.log("Popup blocked or failed to open, creating download link");

      // Create a download link as fallback
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `Raport_NIS2_${
        (data.inputs[0] as pdfInputData)?.denumire || "Entitate"
      }.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
      }, 100);
    } else {
      // Clean up the URL object after a delay to ensure the browser has loaded it
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 30000);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert(
      "A apărut o eroare la generarea raportului PDF. Vă rugăm să încercați din nou."
    );
  }
}
